"user strict";
import getters from './getters';
import actions from './actions';

export default {
    namespaced: true,
    state: () => ({
        _luStateAppResourceCollection: [
            {
                uuid: null,
                countryId: null,
                createdAt: null,
                deletedAt: null,
                updatedAt: null,
                description: null,
                id: null,
                isEnabled: null,
                slug: null,
                title: null,
                meta: {},

            }
        ],

        _counter:0,
    }),
    getters,
    actions,
};


